import React, { FC } from 'react';
import { Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { apiMessagesGetFormRules } from '../../../middleware';
import { tF } from '../../../translate';
import { Catcher } from '../../Catcher';
import ViewStyles from '../../styles/m_viewStyles.less';

type IForm2FAPassword = {
    disableLabelUser?: string;
};

export const Form2FAPassword: FC<IForm2FAPassword> = ({ disableLabelUser }: IForm2FAPassword) => {
    // ToDo: 26.05.2025 -  add translate

    return (
        <Catcher>
            <div className={ViewStyles.body}>
                <div className={ViewStyles.text}>
                    {disableLabelUser ? (
                        <p>You are about to disable 2-Step Authentication for {disableLabelUser}. </p>
                    ) : null}
                    <p>Please, enter your password to proceed:</p>
                </div>
                <Form.Item name="secretWord" label={tF('Password')} rules={apiMessagesGetFormRules}>
                    <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder={tF('Password')}
                    />
                </Form.Item>
            </div>
        </Catcher>
    );
};
